import { FederationModel } from './federation-model';

export class AuthSessionInfoModel {
  authenticationLocalId: string|null;
  federations: FederationModel[];
  lastUserAuditDate: Date|null;
  originatingIPAddress: string;
}
